import { Container, Link, Text } from '@melio/penny';

export const TermsFooter = () => {
  return (
    <Container textAlign="center">
      <Text textStyle="body4" color="semantic.text.secondary">
        By continuing, you are agreeing to Melio&apos;s{' '}
        <Link
          href="https://melio.com/terms-of-service/"
          color="inherit"
          label="Terms of Service"
          variant="inline"
          newTab
          data-testid="terms-link"
        />{' '}
        and{' '}
        <Link
          href="https://melio.com/privacy-policy/"
          color="inherit"
          label="Privacy Policy"
          variant="inline"
          newTab
          data-testid="privacy-link"
        />
        .
      </Text>
    </Container>
  );
};
